import { getBuildDefaultLocale } from '../config/market'

export { SUPPORTED_LOCALES } from './supported-locales'

/** Lingua predefinita alla prima visita (nessuna preferenza salvata e browser non in lista), da config mercato/build. */
export const DEFAULT_LOCALE = getBuildDefaultLocale()
